// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1NpDm","noInteraction":"EventWrapper_noInteraction__RRjyo"};